<section class="sidebar-section">
  @if (handoff) {
    <div class="summary-card">
      <op-handoff-summary-card [row]="handoff" />
    </div>
  }
</section>

<section class="sidebar-section">
  <div class="section-header orders-header">
    <h2>{{ orders.length }} Order/s</h2>
    <button class="primary-blue-btn create-order-btn" type="button" (click)="createOrderClicked.emit()">
      <mat-icon aria-hidden="true">add</mat-icon>
      Create Order
    </button>
  </div>

  @if (ordersLoading) {
    <div class="orders-loading">
      <mat-progress-spinner mode="indeterminate" diameter="28"></mat-progress-spinner>
    </div>
  }

  <div class="orders-list">
    @for (order of orders; track order.id) {
      <div class="order-row">
        <div class="order-row-title" [title]="orderTitle(order)">{{ orderTitle(order) }}</div>

        <div class="order-row-actions">
          <button class="row-btn summary-btn" type="button" (click)="showSummary.emit(order)">Summary</button>
          <button class="row-btn edit-order-btn" type="button" (click)="editOrder.emit(order)">Edit Order</button>

          <mat-select
            class="row-status-select"
            [class.tone-blue]="statusTone(selectedStatus(order)) === 'blue'"
            [class.tone-orange]="statusTone(selectedStatus(order)) === 'orange'"
            [class.tone-red]="statusTone(selectedStatus(order)) === 'red'"
            [class.tone-green]="statusTone(selectedStatus(order)) === 'green'"
            [class.pending]="!!pendingStatusFor(order)"
            [value]="selectedStatus(order)"
            [disabled]="isOrderSaving(order.id) || demoMode"
            panelClass="status-panel"
            (selectionChange)="onStatusChange(order, $event.value)"
          >
            @for (opt of allowedStatusOptions(order); track opt.value) {
              <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
            }
            @if (blockedStatusOptions(order).length) {
              <mat-optgroup [label]="blockedGroupLabel(order)">
                @for (opt of blockedStatusOptions(order); track opt.value) {
                  <mat-option [value]="opt.value" disabled>{{ opt.label }}</mat-option>
                }
              </mat-optgroup>
            }
          </mat-select>
        </div>

        @if (pendingStatusFor(order); as pending) {
          <div class="status-confirm" role="status">
            <span class="status-confirm-text">
              {{ statusLabel(order.status) }} → <strong>{{ statusLabel(pending) }}</strong>
            </span>
            <div class="status-confirm-actions">
              <button
                class="row-btn status-cancel-btn"
                type="button"
                (click)="cancelStatusChange(order)"
              >Cancel</button>
              <button
                class="row-btn status-save-btn"
                type="button"
                [disabled]="isOrderSaving(order.id)"
                (click)="confirmStatusChange(order)"
              >{{ isOrderSaving(order.id) ? 'Saving…' : 'Save' }}</button>
            </div>
          </div>
        }
      </div>
    }
  </div>
</section>

<section class="sidebar-section return-section">
  <button
    class="return-to-ai-btn"
    type="button"
    [disabled]="returningToAi || demoMode"
    (click)="returnToAiClicked.emit()"
  >
    {{ returningToAi ? 'Returning…' : 'Return to Eldara' }}
  </button>
</section>
